import { HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoaderService } from '@services';

let permissionFirstTime = true;

export function loaderInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  // Inject the current `AuthService` and use it to get an authentication token:
  const loaderService = inject(LoaderService);
  const router = inject(Router);

  if (loaderService.ignoreAll) {
    return next(request);
  }
  if (loaderService.excludedUiUrls.find(excludedUrl => router.url.includes(excludedUrl))) {
    return next(request);
  }
  for (const regexUrlItem of loaderService.getRegexEndpoints()) {
    if (regexUrlItem.test(request.url) && !permissionFirstTime) {
      return next(request);
    }
  }

  /**
   * Ignore loader on welcome screen (path = / and there is no navigation)
   * but show it when we click on a project or
   * when we create a project (POST and PUT methods in creation)
   */
  if (
    location.pathname === '/' &&
    !router.getCurrentNavigation() &&
    request.method !== 'PUT' &&
    request.method !== 'POST'
  ) {
    return next(request);
  }
  if (request.url.includes('results') && !request.url.includes('results/export')) {
    return next(request);
  }
  const ignoreNext = loaderService.ignoreNext;
  if (ignoreNext && request.url.includes(ignoreNext)) {
    loaderService.setIgnoreNext(undefined);
    return next(request);
  }
  if (request.url.slice(-4) === '.svg') {
    return next(request);
  }
  if (request) {
    if (request.url.includes('permissions')) {
      permissionFirstTime = false;
    }
    loaderService.start();
  }
  return next(request).pipe(
    map(event => {
      if (event instanceof HttpResponse && request) {
        loaderService.end();
      }
      return event;
    }),
  );
}
